import React from "react";
import Weather from "./Weather";
import './App.css';

export default function App() {
   
  return (
    <div className="App">
      <div className="container">
          <div className="row">
            <div className="col">
              <h1>React Weather App</h1>
            </div>
          </div>
          <Weather defaultCity="Fagnano Olona" />
          <footer>
            This project was coded by{" "}
            <a href="https://github.com/Lotte90/" target="_blank" rel="noreferrer">Lotte90</a> 
            {" "}and is{" "}
            <a href="https://github.com/Lotte90/weather_app_reactjs" target="_blank" rel="noreferrer">open-sourced on Github</a>
            {" "}and{" "}
            <a href="https://brilliant-clafoutis-27c775.netlify.app/" target="_blank" rel="noreferrer">hosted on Netlify</a>
          </footer>
      </div>
    </div>
  );
}